import { FiMenu, FiLogOut, FiZap } from "react-icons/fi";
import { Link } from "react-router-dom";


export default function Header({ user, handleLogout, toggleSidebar }) {
    return (
        <header className="h-16 bg-[#161B22] border-b border-[#21262D] flex items-center justify-between px-4 sm:px-6 fixed top-0 left-0 right-0 xl:left-64 z-20">
        
        {/* Menu Burger (mobile) */}
        <button
        onClick={toggleSidebar}
        className="xl:hidden p-2 text-[#8B949E] hover:text-[#3B82F6] transition"
        >
        <FiMenu size={22} />
        </button>

        {/* ✅ Titre Desktop */}
        <h2 className="hidden xl:block text-lg font-semibold text-[#E6EDF3]">
        Welcome back 👋
        </h2>

        {/* ✅ Titre Mobile */}
        <h2 className="xl:hidden text-lg font-bold bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">
        BoostMyHook
        </h2>

        {/* Profil + logout */}
        <div className="flex items-center gap-3">

            {/* Email */}
            <p className="text-[#8B949E] text-sm hidden sm:block">
            {user?.email}
            </p>

            {/* Tokens */}
            <p className="text-[#8B949E] text-sm flex items-center gap-1 hidden sm:flex">
            <FiZap size={16} className="text-white" /> {/* icône en noir/blanc */}
            {user?.tokens ?? 0}
            </p>

            {/* Avatar */}
            <Link to={'/dashboard/settings'}>
                <img
                src={`https://ui-avatars.com/api/?name=${user?.email}&background=3B82F6&color=ffffff`}
                alt="avatar"
                className="w-8 h-8 rounded-full border border-[#21262D] shadow-[0_0_10px_#3B82F6]/40"
                />
            </Link>

            {/* Logout */}
            <button
            onClick={handleLogout}
            className="flex items-center gap-2 bg-[#21262D] hover:bg-[#3B82F6]/20 text-[#E6EDF3] text-sm font-medium px-3 py-1.5 rounded-lg transition-all duration-200"
            >
            <FiLogOut size={16} />
            <span className="hidden sm:inline">Logout</span>
            </button>
        </div>
        </header>
    );
}
